export const DataHooks = {
  Root: 'Skeleton.Root',
} as const;
